import { useState } from 'react';

const UserModel = () => {
  const [categoryList, setCategoryList] = useState([]);

  const state = {
    categoryList,
  };
  const actions = {
    setCategoryList,
  };

  return {
    ...state,
    ...actions,
  };
};

export default UserModel;
